import React from 'react';
import { ArrowLeft } from 'lucide-react';

const ToolHeader = ({ title, description, onBack }) => {
  return (
    <div className="mb-8">
      <button
        onClick={onBack}
        className="inline-flex items-center gap-2 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white font-semibold mb-4 transition-colors group"
      >
        <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
        <span>Back to Tools</span>
      </button>
      
      <div>
        <h2 className="text-3xl md:text-4xl font-black text-slate-900 dark:text-white mb-3">
          {title}
        </h2>
        <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl">
          {description}
        </p>
      </div>
    </div>
  );
};

export default ToolHeader;
